import { Button, CircularProgress, Box } from "@mui/material";

const LoadingButton = ({ children, loading, disabled, ...props }) => {
    return (
        <Box sx={{ position: "relative" }}>
            <Button disabled={disabled || loading} {...props}>
                {children}
            </Button>
            {loading && (
                <CircularProgress
                    size={24}
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                    }}
                />
            )}
        </Box>
    );
};

export default LoadingButton;
